


































































import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import Paginater from "@/components/Paginater.vue";
import HacoBase from "../HacoBase";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import Scenario from "../views/Scenario.vue";
import { getCalcTypes } from "../model/CalcType";
@Component({
  components: {
    ToggleSwitch,
    Paginater
  }
})
export default class ScenarioList extends HacoBase {
  scenarioObj: Scenario[] = [];
  $debugServer!: string;
  calcTypes = getCalcTypes();
  @Prop({ type: String, required: false }) private dialogText!: string;

  mounted(): void {
    this.loadListData();
  }

  loadListData(pagedUrl = ""): void {
    const url =
      pagedUrl === "" ? this.$debugServer + "/api/v1_inner/scenario" : pagedUrl;
    const params: object = this.setAxiosParams(url, "get");
    // データ取ってくる
    axios(params)
      .then((response: any): void => {
        this.scenarioObj = response.data.scenario as Scenario[];
        this.putPageData(response.data.paginate);
      })
      .catch((error: any): void => {
        console.log("[error]", error.response);
        this.toLoginPage(error);
      });
  }

  movePage(page: string | number): void {
    if (this.pagination.currentPage === page) {
      return;
    }
    this.loadListData(this.getPage(page));
  }

  openEditPage(scenarioId: number): void {
    this.$router.push({
      name: "ScenarioEdit",
      params: { id: scenarioId.toString() }
    });
  }
}
